import { OPENAI_MODEL_CATALOG } from '../openAiModelCatalog';
import { ModelCombobox } from './ModelCombobox';

/**
 * Thin `ModelCombobox` wrapper over `OPENAI_MODEL_CATALOG` (spec 160 R2) —
 * see `ModelCombobox.tsx` for the shared search/grouping/free-text behavior.
 */
export function OpenAiModelCombobox({
  idPrefix,
  value,
  onChange,
  id,
  disabled = false,
  autoFocus,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}: {
  /** The selected harness's `model_id_prefix` (spec 205); absent means plain ids. */
  idPrefix?: string | null;
  value: string;
  onChange: (model: string) => void;
  id?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  'aria-invalid'?: boolean;
  'aria-describedby'?: string;
}) {
  return (
    <ModelCombobox
      catalog={OPENAI_MODEL_CATALOG}
      idPrefix={idPrefix}
      value={value}
      onChange={onChange}
      id={id}
      placeholder="gpt-4.1"
      disabled={disabled}
      autoFocus={autoFocus}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
    />
  );
}
